module.exports = __webpack_public_path__ + "static/img/edit_participant.25b2f555.svg";